module.exports = __webpack_public_path__ + "img/_2.f373e039.png";